var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container login" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-9 col-md-7 col-lg-5 mx-auto" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card card-signin my-5" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h5", { staticClass: "card-title text-center" }, [
              _vm._v("Reset Password")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.error,
                    expression: "error"
                  }
                ],
                staticClass: "alert alert-danger"
              },
              [_vm._v(_vm._s(_vm.error))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.success,
                    expression: "success"
                  }
                ],
                staticClass: "alert alert-success"
              },
              [_vm._v(_vm._s(_vm.success))]
            ),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "form-signin",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.resetPassword.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "form-label-group" },
                  [
                    (_vm.showPassword ? "text" : "password") === "checkbox"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "password",
                            placeholder: "Password",
                            required: "",
                            autofocus: "",
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.password)
                              ? _vm._i(_vm.password, null) > -1
                              : _vm.password
                          },
                          on: {
                            input: function($event) {
                              return _vm.validatePassword($event.target.value)
                            },
                            change: function($event) {
                              var $$a = _vm.password,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.password = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.password = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.password = $$c
                              }
                            }
                          }
                        })
                      : (_vm.showPassword ? "text" : "password") === "radio"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "password",
                            placeholder: "Password",
                            required: "",
                            autofocus: "",
                            type: "radio"
                          },
                          domProps: { checked: _vm._q(_vm.password, null) },
                          on: {
                            input: function($event) {
                              return _vm.validatePassword($event.target.value)
                            },
                            change: function($event) {
                              _vm.password = null
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "password",
                            placeholder: "Password",
                            required: "",
                            autofocus: "",
                            type: _vm.showPassword ? "text" : "password"
                          },
                          domProps: { value: _vm.password },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.password = $event.target.value
                              },
                              function($event) {
                                return _vm.validatePassword($event.target.value)
                              }
                            ]
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "toggle-password top-45",
                        on: { click: _vm.togglePassword }
                      },
                      [
                        _vm.showPassword
                          ? _c("i", { staticClass: "fas fa-eye" })
                          : _c("i", { staticClass: "fas fa-eye-slash" })
                      ]
                    ),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "password" } }, [
                      _vm._v("Password")
                    ]),
                    _vm._v(" "),
                    _c("password", {
                      staticStyle: {
                        "max-width": "unset",
                        margin: "0",
                        "margin-bottom": "-10px"
                      },
                      attrs: { "strength-meter-only": true },
                      model: {
                        value: _vm.password,
                        callback: function($$v) {
                          _vm.password = $$v
                        },
                        expression: "password"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-label-group" }, [
                  (_vm.showConfirmPassword ? "text" : "password") === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password_confirmation,
                            expression: "password_confirmation"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "confirmPassword",
                          placeholder: "Confirm Password",
                          required: "",
                          autofocus: "",
                          type: "checkbox"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.password_confirmation)
                            ? _vm._i(_vm.password_confirmation, null) > -1
                            : _vm.password_confirmation
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.password_confirmation,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.password_confirmation = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.password_confirmation = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.password_confirmation = $$c
                            }
                          }
                        }
                      })
                    : (_vm.showConfirmPassword ? "text" : "password") ===
                      "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password_confirmation,
                            expression: "password_confirmation"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "confirmPassword",
                          placeholder: "Confirm Password",
                          required: "",
                          autofocus: "",
                          type: "radio"
                        },
                        domProps: {
                          checked: _vm._q(_vm.password_confirmation, null)
                        },
                        on: {
                          change: function($event) {
                            _vm.password_confirmation = null
                          }
                        }
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password_confirmation,
                            expression: "password_confirmation"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "confirmPassword",
                          placeholder: "Confirm Password",
                          required: "",
                          autofocus: "",
                          type: _vm.showConfirmPassword ? "text" : "password"
                        },
                        domProps: { value: _vm.password_confirmation },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password_confirmation = $event.target.value
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "toggle-password top-50",
                      on: { click: _vm.toggleConfirmPassword }
                    },
                    [
                      _vm.showConfirmPassword
                        ? _c("i", { staticClass: "fas fa-eye" })
                        : _c("i", { staticClass: "fas fa-eye-slash" })
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "confirmPassword" } }, [
                    _vm._v("Confirm Password")
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("ul", { staticClass: "password-checklist" }, [
                    _c(
                      "li",
                      {
                        class: {
                          "pw-list-item": true,
                          pass: _vm.checkPwConditionReached("min") == "pass",
                          error: _vm.checkPwConditionReached("min") == "err"
                        }
                      },
                      [
                        _c("span", { staticClass: "pw-list-check" }, [
                          _c("i", { class: "fas " + _vm.getPwListIcon("min") })
                        ]),
                        _vm._v(" At least 8 letters\n                  ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: {
                          "pw-list-item": true,
                          pass:
                            _vm.checkPwConditionReached("uppercase") == "pass",
                          error:
                            _vm.checkPwConditionReached("uppercase") == "err"
                        }
                      },
                      [
                        _c("span", { staticClass: "pw-list-check" }, [
                          _c("i", {
                            class: "fas " + _vm.getPwListIcon("uppercase")
                          })
                        ]),
                        _vm._v(" At least 1 capital letter\n                  ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: {
                          "pw-list-item": true,
                          pass:
                            _vm.checkPwConditionReached("lowercase") == "pass",
                          error:
                            _vm.checkPwConditionReached("lowercase") == "err"
                        }
                      },
                      [
                        _c("span", { staticClass: "pw-list-check" }, [
                          _c("i", {
                            class: "fas " + _vm.getPwListIcon("lowercase")
                          })
                        ]),
                        _vm._v(
                          " At least 1 lower case letter\n                  "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: {
                          "pw-list-item": true,
                          pass:
                            _vm.checkPwConditionReached("symbols") == "pass",
                          error: _vm.checkPwConditionReached("symbols") == "err"
                        }
                      },
                      [
                        _c("span", { staticClass: "pw-list-check" }, [
                          _c("i", {
                            class: "fas " + _vm.getPwListIcon("symbols")
                          })
                        ]),
                        _vm._v(
                          " At least 1 special character (!$#@%^*&{}[]<>)\n                  "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: {
                          "pw-list-item": true,
                          pass: _vm.checkPwConditionReached("digits") == "pass",
                          error: _vm.checkPwConditionReached("digits") == "err"
                        }
                      },
                      [
                        _c("span", { staticClass: "pw-list-check" }, [
                          _c("i", {
                            class: "fas " + _vm.getPwListIcon("digits")
                          })
                        ]),
                        _vm._v(" At least 1 numeric digit\n                  ")
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-lg btn-primary btn-block text-uppercase",
                    attrs: { type: "submit" }
                  },
                  [_vm._v("Reset")]
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass:
                      "btn btn-lg btn-success btn-block text-uppercase",
                    attrs: { to: "/login" }
                  },
                  [_vm._v("Back to Login")]
                )
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", { attrs: { src: require("@/csmworkflow/img/logo.svg") } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }